import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogDetailRequestBody, BlogDetailResponse } from "./types";

export class BlogDetailAPI extends BaseAPI<
  BlogDetailRequestBody,
  BlogDetailResponse
  > {
    protected route = ApiRoutes.blog.details;
    protected method = RequestMethod.GET;
    protected params = ["id"];
  }
